import { render } from "./GameScreen.vue?vue&type=template&id=187266c1&scoped=true"
import script from "./GameScreen.vue?vue&type=script&lang=js"
export * from "./GameScreen.vue?vue&type=script&lang=js"

import "./GameScreen.vue?vue&type=style&index=0&id=187266c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187266c1"]])

export default __exports__